import request from '../utils/request'

export function listcate(data) {
    return request({
        url: '/api/open/uni/listcate?pageSize='+data.pageSize+'&parent_cate_value='+data.parent_cate_value,
        method: 'get'
    })
}

export function listcompany3(data){
    return request({
        url: '/api/open/uni/listcompany3?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&keywords='+data.keywords,
        method: 'get'
    })
}

export function join(data){
    return request({
        url: '/api/company/join',
        method: 'post',
        data
    })
}

export function expertJoin(data){
    return request({
        url: '/api/expert/join',
        method: 'post',
        data
    })
}

export function listByUser(data){
    return request({
        url: '/api/company/listByUser?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&keywords='+data.keywords,
        method: 'get',
        headers: {
            token: localStorage.getItem("token")
        }
    })
}

export function companyList(data){
    return request({
        url: '/api/company/list',
        method: 'get',
        params: data
    })
}

export function host(data){
    let host = data.host
    delete data.host;
    return request({
        url: host,
        method: 'post',
        data
    })
}

export function infoByUserId(data){
    return request({
        url: '/api/company2/infoByUserId',
        method: 'get'
    })
}
export function listcates(data){
    return request({
        url: '/api/open/uni/listcates?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&cate_values='+data.cate_values,
        method: 'get'
    })
}

export function joinUser(data){
    return request({
        url: '/api/company2/join',
        method: 'post',
        data
    })
}

export function join2Usre(data){
    return request({
        url: '/api/open/uni/company/join2',
        method: 'post',
        data
    })
}